import { render, staticRenderFns } from "./InfoJustEat.vue?vue&type=template&id=9fc5fc54"
import script from "./InfoJustEat.vue?vue&type=script&lang=js"
export * from "./InfoJustEat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports